<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          Brands
        </div>
        <div class="col-6">
          <brand-create v-if="$store.getters.isAdmin" />
        </div>
      </div>
    </div>
    <div v-loading="loading">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th>Name</th>
            <th v-if="$store.getters.isAdmin">Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="brand in brands" :key="brand.id">
            <td><router-link :to="{ name: 'brands-id', params: { id: brand.id } }">{{ brand.name }}</router-link></td>
            <td v-if="$store.getters.isAdmin">
              <brand-delete :brandId="brand.id" @delete="getBrands" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BrandCreate from '@/components/Brand/BrandCreate'
import BrandDelete from '@/components/Brand/BrandDelete'

export default {
  components: {
    BrandCreate,
    BrandDelete,
  },

  data() {
    return {
      loading: false,
      brands: [],
    }
  },

  mounted() {
    this.getBrands()
  },

  methods: {
    async getBrands() {
      this.loading = true

      try {
        var { data } = await this.$http.get('/brands')
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.brands = data
    },
  },
}
</script>
